import React from "react";
import MainPageLayout from "../layouts/MainPageLayout";

const JudgesClerks = () => {
  return (
    <>
      <MainPageLayout
        pageEndpoint={
          "pages?filters[slug][$eq]=judges-%26-clerks"
        }
      />
    </>
  );
};

export default JudgesClerks;
